import React, { useCallback, useRef, useState, useEffect } from 'react'
import { SLowcodeList, STableActions, SActionBtn } from 'shj-components'
import { Button, Col, DatePicker, Row, Table, Tabs, Divider } from 'antd'
import { get } from 'lodash-es'
import { weatherCurrent } from '@/services/homeService'
import styles from '../../index.module.less'

const { RangePicker } = DatePicker

const weather = (props: any) => {
  const [details, setDetails] = useState({})

  useEffect(() => {
    initFn()

    return () => {}
  }, [])

  const initFn = () => {
    weatherCurrent().then(res => {
      let data = res.result
      data.realtime.aqi = data.realtime.aqi ? parseInt(data.realtime.aqi) : ''
      if (data.realtime.aqi) {
        if (data.realtime.aqi <= 50) {
          data.realtime.apiTitle = '优'
        } else if (data.realtime.aqi > 50 && data.realtime.aqi <= 100) {
          data.realtime.apiTitle = '良好'
        } else if (data.realtime.aqi > 100 && data.realtime.aqi <= 150) {
          data.realtime.apiTitle = '轻度污染'
        } else if (data.realtime.aqi > 150 && data.realtime.aqi <= 200) {
          data.realtime.apiTitle = '中度污染'
        } else if (data.realtime.aqi > 200 && data.realtime.aqi <= 300) {
          data.realtime.apiTitle = '重度污染'
        } else if (data.realtime.aqi > 300) {
          data.realtime.apiTitle = '严重污染'
        }
      } else {
        data.realtime.apiTitle = '暂无'
      }
      let url = ''
      switch (data.realtime.wid) {
        case '00':
          url = require('@/assets/qing.png')
          break
        case '03':
        case '04':
        case '05':
        case '06':
        case '07':
        case '08':
        case '09':
        case '10':
        case '11':
        case '12':
        case '19':
        case '21':
        case '22':
        case '23':
        case '24':
        case '25':
          url = require('@/assets/yu.png')
          break
        case '13':
        case '14':
        case '15':
        case '16':
        case '17':
        case '26':
        case '27':
        case '28':
          url = require('@/assets/xue.png')
          break

        case '29':
        case '30':
        case '31':
        case '20':
          url = require('@/assets/shachen.png')
          break
        default:
          url = require('@/assets/duoyun.png')
          break
      }
      data.realtime.url = url
      setDetails(res.result)
    })
  }

  return (
    <div className={styles.weatherContent}>
      <div className={styles.temperatureContent}>
        <div className={styles.temperatureBox}>
          <div className={styles.temperature}>{details?.realtime?.temperature}</div>
          <div>
            <div className={styles.maxTemperature}>
              {details?.future && details?.future[0]?.temperature}
            </div>
            <div className={styles.temperatureTitle}>{details?.realtime?.info}</div>
          </div>
        </div>

        <img src={details?.realtime?.url} style={{ width: '107px', height: '95px' }} />
      </div>
      <div className={styles.infoContent}>
        <div>空气质量{details?.realtime?.apiTitle}</div>
        <Divider type="vertical" />
        <div>湿度{details?.realtime?.humidity}%</div>
        <Divider type="vertical" />
        <div>{details?.realtime?.direct}</div>
      </div>
    </div>
  )
}
export default weather
